export default {
  "title": {
    "evolution": "Eventos de somnolencia / 100hr conducción diarios",
    "quantityEvolution": "Cantidad diaria de eventos de somnolencia",
    "totalEvents": "Total de eventos de somnolencia",
    "ranking": "Ranking de conductores"
  },
  "labels": {
    "microsleepsKpi": "Eventos de somnolencia / 100 hr conducción",
    "totalMicrosleeps": "Total de eventos de somnolencia",
    "graphTooltip": "Eventos de somnolencia"
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/spanish/road_warning/detailRoadWarning.js